export default __webpack_public_path__ + "static/media/help-self.857d0108.svg";